import React from 'react';
import { styled } from '@compiled/react';
import Button from '@atlaskit/button';
import Heading from '@atlaskit/heading';
import { token } from '@atlaskit/tokens';
import { fg } from '@atlassian/jira-feature-gating';
import { useIntl } from '@atlassian/jira-intl';
import errorImgUrl from './assets/error.svg';
import messages from './messages.tsx';

export const ErrorView = () => {
	const { formatMessage } = useIntl();

	return (
		<Container>
			<Img
				src={errorImgUrl}
				alt={formatMessage(
					fg('jira-issue-terminology-update-m4')
						? messages.errorImageAltIssueTerminologyRefreshM4
						: messages.errorImageAlt,
				)}
			/>
			<Heading size="small">
				{formatMessage(
					fg('jira-issue-terminology-update-m4')
						? messages.failToLoadTitleNonFianlIssueTerminologyRefreshM4
						: messages.failToLoadTitleNonFianl,
				)}
			</Heading>
			<ButtonContainer>
				<Button
					appearance="link"
					onClick={() => {
						// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
						window.location.reload();
					}}
				>
					{formatMessage(messages.refreshButtonLabel)}
				</Button>
			</ButtonContainer>
		</Container>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Container = styled.div({
	paddingTop: token('space.1000'),
	display: 'flex',
	flexDirection: 'column',
	alignItems: 'center',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Img = styled.img({
	marginBottom: token('space.400'),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ButtonContainer = styled.p({
	marginTop: token('space.100'),
});
